/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PaymentConfigCreate } from '../models/PaymentConfigCreate';
import type { PaymentConfigDetails } from '../models/PaymentConfigDetails';
import type { PaymentConfigUpdate } from '../models/PaymentConfigUpdate';
import { request as __request } from '../core/request';

export class PaymentConfigsVService {

    /**
     * @param configId
     * @param districtId
     * @param requestBody
     * @returns PaymentConfigDetails OK
     * @throws ApiError
     */
    public static async paymentConfigsVUpdatePaymentConfigs(
        configId: string,
        districtId: string,
        requestBody?: PaymentConfigUpdate,
    ): Promise<PaymentConfigDetails> {
        const result = await __request({
            method: 'PATCH',
            path: `/api/v2/districts/${districtId}/payment-config/${configId}`,
            body: requestBody,
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
        return result.body;
    }

    /**
     * @param districtId
     * @returns PaymentConfigDetails OK
     * @throws ApiError
     */
    public static async paymentConfigsVGetDistrictPaymentConfig(
        districtId: string,
    ): Promise<PaymentConfigDetails> {
        const result = await __request({
            method: 'GET',
            path: `/api/v2/districts/${districtId}/payment-config`,
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
            },
        });
        return result.body;
    }

    /**
     * @param districtId
     * @param requestBody
     * @returns PaymentConfigDetails Created
     * @throws ApiError
     */
    public static async paymentConfigsVCreate(
        districtId: string,
        requestBody?: PaymentConfigCreate,
    ): Promise<PaymentConfigDetails> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/districts/${districtId}/payment-config`,
            body: requestBody,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
            },
        });
        return result.body;
    }

}